import { type PropsWithChildren } from 'react';
import { css, cx, type Styles } from '../../../../../../styled-system/css';
import {
  iconButton,
  type IconButtonVariantProps,
} from '../../../../../../styled-system/recipes';

export type IconButtonProps = IconButtonVariantProps & {
  css?: Styles;
  disabled?: boolean;
  onClick: () => void | Promise<void>;
  tooltip?: string;
};

export const IconButton = ({
  children,
  css: cssProp,
  tooltip,
  use,
  ...props
}: PropsWithChildren<IconButtonProps>) => {
  return (
    <button
      {...props}
      className={cx(iconButton({ use }), css(cssProp))}
      title={tooltip}
    >
      {children}
    </button>
  );
};
